import { makeAutoObservable, runInAction } from "mobx";
import { geoClient } from "../rpc/clients";

class GeoStore {
  fetching = false;
  fetched = false;
  countryCode: string | null = null;
  countryName: string | null = null;
  private inFlight: Promise<void> | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetch(force = false) {
    if (this.fetched && !force) return;
    if (this.inFlight) return this.inFlight;

    runInAction(() => {
      this.fetching = true;
    });
    this.inFlight = (async () => {
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const res = await geoClient.getGeo(
          {},
          timezone
            ? {
                headers: { "X-Timezone": timezone },
              }
            : undefined,
        );

        runInAction(() => {
          if (res.countryCode && res.countryCode !== "XX") {
            this.countryCode = res.countryCode;
            this.countryName = res.countryName || null;
          }
          this.fetched = true;
        });
      } catch {
        runInAction(() => {
          this.fetched = true;
        });
      } finally {
        runInAction(() => {
          this.fetching = false;
        });
        this.inFlight = null;
      }
    })();
    return this.inFlight;
  }
}

export const geoStore = new GeoStore();
